import React from "react";

const shellClassName =
  "pointer-events-none inline-flex items-center justify-center rounded-lg border text-xs font-medium h-8 max-md:min-h-[44px] max-md:px-3 px-2.5 border-white/10 bg-white/[0.06] text-blue-100";

/**
 * Datei-Button mit Input direkt darüber — natives OS-Menü erscheint am Tap-Punkt
 * (nicht am Seitenende wie bei display:none + htmlFor).
 */
const FilePickButton = React.forwardRef(function FilePickButton(
  {
    id,
    accept = "",
    multiple = false,
    onChange,
    disabled = false,
    children = "Datei auswählen",
    className = "",
    title = "",
    shellClassName: shellCls = "",
  },
  ref,
) {
  return (
    <div className={`relative inline-flex max-w-full ${className}`}>
      <input
        ref={ref}
        id={id}
        type="file"
        accept={accept}
        multiple={multiple || undefined}
        disabled={disabled}
        onChange={onChange}
        title={title}
        aria-label={typeof children === "string" ? children : "Datei auswählen"}
        className="absolute inset-0 z-10 h-full w-full min-h-[44px] min-w-[10rem] cursor-pointer opacity-0 disabled:cursor-not-allowed"
      />
      <span className={`${shellClassName} ${shellCls}`.trim()}>{children}</span>
    </div>
  );
});

export default FilePickButton;
